import React from "react";
import OrderTable from "../Table";

const DeliveryAssigned = () => {
  return <OrderTable type="Delivery Assigned" />;
};

export default DeliveryAssigned;
